import Utils from "@/utilities/Utils";
import { UserRole, UserStatus } from "@/model/Enums";
import { mapData } from "@/utilities/DataMapping";

export interface IUser {
    id: string;
    status: UserStatus;
    statusInfo: string;
    role: UserRole;
    isUserAdmin: boolean;
    clientIDs: Array<string>;
    siteID: string;

    sponsorRecipientIDs: Array<string>;
    pathwayIDs: Array<string>;

    email: string;
    forename: string;
    surname: string;
    lastLoggedIn: Date;
    prevLastLoggedIn: Date;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;

    siteHasWorkPermitForms: boolean;
}

export class User implements IUser {

    constructor(data?: IUser) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IUser): User {
        mapData(data, { root: () => this });
        return this;
    }

    id: string = Utils.emptyGuidValue;
    status: UserStatus = UserStatus.None;
    statusInfo: string = "";
    role: UserRole = UserRole.None;
    isUserAdmin: boolean = false;
    clientIDs: Array<string> = [];
    siteID: string = Utils.emptyGuidValue;
    sponsorRecipientIDs: Array<string> = [];
    pathwayIDs: Array<string> = [];
    email: string = "";
    forename: string = "";
    surname: string = "";
    lastLoggedIn: Date = new Date(Utils.emptyDateValue);
    prevLastLoggedIn: Date = new Date(Utils.emptyDateValue);
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;
    jwtBearerToken: string = "";

    siteHasWorkPermitForms: boolean = false;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }

    get isDeleted() {
        return Utils.hasDateValue(this.deleted);
    }

    get fullname() {
        return this.forename + " " + this.surname;
    }

    get canFilterClient(): boolean {
        return this.role === UserRole.Admin || (this.role === UserRole.Client && this.clientIDs?.length > 1)
    }

    get canFilterSite(): boolean { return this.role === UserRole.Admin || this.role === UserRole.Client; }

    // hack for referring to single client ID (e.g. site user)
    get clientID(): string {
        return this.clientIDs.length === 0 ? Utils.emptyGuidValue :  this.clientIDs[0];
    }
    set clientID(value: string) {
        this.clientIDs = Utils.isEmptyId(value) ? [] : [value];
    }
}